export default (that) => [
  {
    text: that.$l('btn_tips_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_edit') || '编辑计划',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    show: ({ evgPlanOrderStatus }) => evgPlanOrderStatus === 'N',
  },
  {
    text: that.$l('btn_tips_del') || '删除计划',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    show: ({ evgPlanOrderStatus }) => evgPlanOrderStatus === 'N',
  },
  {
    text: that.$l('btn_tips_confirm') || '确认计划',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'C',
    data: {},
    show: ({ evgPlanOrderStatus }) => evgPlanOrderStatus === 'N',
  },
]
